<script setup lang="ts">
import Typography from '@components/Typography.vue';
import SubmenuItem from '@app/layout/nav/SubmenuItem.vue';
import type { Url } from '@global-types/url.ts';
import { useAppDataStore } from '@stores/useAppDataStore.ts';
import { computed } from 'vue';

const { link } = defineProps<{ link: Url }>();

const { baseUrl } = useAppDataStore();

const absoluteLink = computed<Url>(() => baseUrl + link);
</script>

<template>
  <SubmenuItem
    class="group !p-2"
    :link="absoluteLink"
  >
    <Typography
      variant="body"
      color="gray-darker"
      class="group-hover:text-black"
    >
      <slot />
    </Typography>
  </SubmenuItem>
</template>
